<template>
  <TrainerLayout>
    <div class="">
      <div v-if="deleteSessionPopUp">
        <ConfirmationAlert
          @sessionDeleteModalEvent="openConfrimDeletePopUp"
          :message="message"
        />
      </div>
      <div>
        <div class="flex items-center justify-between mb-8">
          <h1 class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight">
            Class Details
          </h1>
          <ul
            class="flex items-center space-x-2"
            v-for="s in trainerSessionView.session &&
            trainerSessionView.session.details"
            :key="s.id"
          >
            <li
              class="inline-flex items-center h-8 px-2 text-sm text-indigo-100 transition-colors duration-150 ring-1 ring-gray-300 bg-gray-100 rounded-lg focus:shadow-outline hover:bg-blue-light"
              title="Delete Class"
              v-if="trainerSessionView.is_booked == 0"
            >
              <button @click="handleSessionDel(s.id)">
                <Trash classStr="text-gray-dark" />
              </button>
            </li>
            <li
              class="inline-flex items-center h-8 px-2 text-sm text-indigo-100 transition-colors duration-150 ring-1 ring-gray-300 bg-gray-100 rounded-lg focus:shadow-outline hover:bg-blue-light"
              title="Disabled: This Session is currently active."
              v-else
            >
              <button>
                <Trash classStr="text-gray-darkest" />
              </button>
            </li>
            <li
              class="inline-flex items-center h-8 px-2 text-sm text-indigo-100 transition-colors duration-150 ring-1 ring-gray-300 bg-gray-100 rounded-lg focus:shadow-outline hover:bg-blue-light"
              title="Edit Class"
              v-if="trainerSessionView.is_booked == 0"
            >
              <router-link :to="{ name: 'SessionEdit', param: { id: s.id } }">
                <Pencil classStr="text-gray-dark" />
              </router-link>
            </li>
            <li
              class="inline-flex items-center h-8 px-2 text-sm text-indigo-100 transition-colors duration-150 ring-1 ring-gray-300 bg-gray-100 rounded-lg focus:shadow-outline hover:bg-blue-light"
              title="Disabled: This Session is currently active."
              v-else
            >
              <button>
                <Pencil classStr="text-gray-darkest" />
              </button>
            </li>
            <button
            type="button"
            class="ring-1 ring-gray-300 p-1 text-gray-light rounded-md focus:bg-green-light focus:text-white focus:outline-none"
            title="Share link"
            @click.prevent="handleShareButton"
          >
            <!-- Share icon -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              viewBox="0 0 33 31"
            >
              <g id="noun_Share_4241699" transform="translate(-0.542 -1.899)">
                <g id="Layer_10" data-name="Layer 10">
                  <path
                    id="Path_2127"
                    data-name="Path 2127"
                    d="M27.9,2.682a.881.881,0,0,0-.51-.276c-.013,0-.023-.007-.036-.007s-.024.007-.037.007a.677.677,0,0,0-.7.69v3.91c-2.219-.142-6.786.172-8.77,4.682C15.108,17.9,18.912,24.1,19.075,24.36a.7.7,0,0,0,.591.328.687.687,0,0,0,.144-.015.7.7,0,0,0,.546-.582c.812-5.616,3.957-8.089,6.262-9.161V20.1a.7.7,0,0,0,1.154.527L37.607,12.1a.7.7,0,0,0,0-1.056Zm.109,15.89v-4.68a.7.7,0,0,0-.93-.658,12.008,12.008,0,0,0-7.691,8.615c-.876-2.142-1.891-5.921-.268-9.6,1.434-3.259,4.494-3.883,6.624-3.883.331,0,.635.016.912.038v.737a.7.7,0,0,0,1.395,0V4.655l8.03,6.923Z"
                    transform="translate(-4.806)"
                    stroke="#222"
                    stroke-width="1"
                  />
                  <path
                    id="Path_2128"
                    data-name="Path 2128"
                    d="M30.256,19.866a.7.7,0,0,0-.7.694v5.931a4.7,4.7,0,0,1-4.7,4.685H7.138a4.7,4.7,0,0,1-4.7-4.685V9.019a4.7,4.7,0,0,1,4.7-4.685h7.89a.694.694,0,1,0,0-1.389H7.138a6.092,6.092,0,0,0-6.1,6.074V26.491a6.092,6.092,0,0,0,6.1,6.074H24.857a6.092,6.092,0,0,0,6.1-6.074V20.56a.7.7,0,0,0-.7-.694Z"
                    transform="translate(0 -0.165)"
                    stroke="#222"
                    stroke-width="1"
                  />
                </g>
              </g>
            </svg>
            </button>
          </ul>
        </div>
        <SessionThumbnailSupporting
          :trainerSessionView="trainerSessionView.session"
          :sessionDetails="
            trainerSessionView.session &&
            trainerSessionView.session.details &&
            trainerSessionView.session.details[0]
          "
          :supportingImages="trainerSessionView.supporting_images"
          :average_rating="
            trainerSessionView.session &&
            trainerSessionView.session.average_rating
          "
          :total_count="
            trainerSessionView.session && trainerSessionView.session.total_count
          "
          :batches="trainerSessionView.batches"
        />
        <ul class="flex justify-between mb-4" v-if="$route.query.activity">
          <li>
            <select
              class="block w-full form-select text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
              v-model="isActivityOpen"
            >
              <option :value="true">Activity</option>
              <!-- <option :value="false">History</option> -->
            </select>
          </li>

          <!-- <li v-if="isActivityOpen == false">
            <router-link
              class="h-8 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light ring-1 ring-green-light rounded-lg focus:outline-none hover:bg-white hover:text-green-light py-2"
              :to="{
                name: 'SessionHistory',
                params: { id: this.$route.params.id },
              }"
              >See All</router-link
            >
          </li> -->
        </ul>
        <!-- v-if="isActivityOpen == true" -->
        <SessionBatchCard
          :data="trainerSessionView.batches"
          v-if="$route.query && $route.query.activity"
        />
        <!-- <SessionHistory
          :data="trainerSessionView.history.data || []"
          v-if="isActivityOpen == false"
        /> -->
      </div>
    </div>
    <Modal v-model="isShareModalOpen" :title="'Share link to Class'">
      <div class="space-y-4">
        <div>
          <p class="text-gray-dark font-semibold mb-4">Share link via</p>
          <ShareNetworkComponent :sharingUrl="sharingUrl" />
        </div>
        <div>
          <p class="text-gray-dark font-semibold mb-4">Share this link</p>
          <div class="flex items-center">
            <input
              class="w-full h-10 px-3 text-base text-gray-700 placeholder-gray-600 ring-1 ring-gray-300 rounded-lg focus:shadow-outline"
              type="text"
              placeholder="Sharing url"
              v-model="sharingUrl"
              disabled
            />
            <button
              type="button"
              class="ml-2 whitespace-nowrap h-10 px-4 text-sm text-green-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light w-32"
              id="copy-url"
              @click.prevent="handleCopyUrlButton"
            >
              Copy URL
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </TrainerLayout>
</template>

<script>
import SessionBatchCard from "@/components/SessionBatchCard";
// import SessionHistory from "@/components/SessionHistory";

import TrainerLayout from "@/components/layouts/TrainerLayout";
import SessionThumbnailSupporting from "@/components/trainer/SessionThumbnailSupporting";
import ShareNetworkComponent from "@/components/social-sharing/ShareNetworkComponent";
import ConfirmationAlert from "@/components/user/ConfirmationAlert";
import { Pencil, Trash } from "@/components/icons";
import { Modal } from "@/components/t-components";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SingleSession",
  components: {
    TrainerLayout,
    SessionThumbnailSupporting,
    SessionBatchCard,
    // SessionHistory,
    Pencil,
    Trash,
    Modal,
    ShareNetworkComponent,
    ConfirmationAlert,
  },
  data() {
    return {
      isActivityOpen: true,
      deleteSessionPopUp: false,
      sessionDeleteId: "",
      message: "",
      isShareModalOpen: false,
      sharingUrl: "",
    };
  },
  computed: {
    ...mapGetters(["trainerSessionView"]),
  },
  methods: {
    ...mapActions(["getTrainerSessionView", "trainerSessionDelete"]),

    handleSessionDel(id) {
      var w = "";
      if (this.trainerSessionView.batches.length == 0) {
        w = "Warning: Are you sure you want to delete this Session?";
      } else {
        w =
          "Warning: This Session is currently active. Are you sure you want to delete?";
      }
      this.message = w;
      this.deleteSessionPopUp = true;
      this.sessionDeleteId = id;
    },

    openConfrimDeletePopUp(val) {
      if (val) {
        this.trainerSessionDelete(this.sessionDeleteId);
        this.$router.push({ name: "sessions", params: { id: "all" } });
      } else {
        this.deleteSessionPopUp = !this.deleteSessionPopUp;
      }
    },

    async handleShareButton() {
      this.isShareModalOpen = !this.isShareModalOpen;
      this.sharingUrl = this.getRouterHref(this.USERSESSIONDETAILS);
    },
    handleCopyUrlButton() {
      if (this.sharingUrl) {
        navigator.clipboard.writeText(this.sharingUrl);
        document.getElementById("copy-url").innerHTML = "Copied";
      }
    }
  },
  created() {
    this.getTrainerSessionView({ id: this.$route.params.id });
  },
};
</script>